export default "__VITE_ASSET__XvHhabB$__"